import { Component, OnInit } from '@angular/core';
import { BoxService } from '../../services/box.service';
import { LocalSession } from '../../providers/local-session.provider';
import { BoxMessage } from '../../models/boxmessage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  constructor(
  	protected boxService: BoxService,
  	protected router: Router,
  	protected localSession: LocalSession) { }

  ngOnInit(): void {
  	if (!this.localSession.isInitialized()) {
  		this.router.navigate(['/Startup']);
  	}
  }

}
